import { useMemo } from 'react'

import { enumCodec, useQueryState } from './useQueryState'

/**
 * URL クエリパラメータでタブ状態を管理するフック。
 *
 * リロードや URL 共有でタブ状態を復元できる。
 * page-tabs.tsx と同じ規約で、デフォルト値のときはパラメータを URL から取り除く。
 *
 * @param paramName クエリパラメータ名 (例: 'tab')
 * @param values 許可するタブ値の一覧。不正な値が URL に入っていた場合は defaultValue にフォールバックする
 * @param defaultValue デフォルトのタブ値
 */
export const useQueryTabState = <T extends string>(
  paramName: string,
  values: readonly T[],
  defaultValue: T,
): [T, (value: T) => void] => {
  const codec = useMemo(() => enumCodec(values, defaultValue), [values, defaultValue])
  return useQueryState(paramName, codec)
}
